import React from 'react';
var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#F96"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "11",
  strokeWidth: "2",
  transform: "matrix(-1 0 0 1 24 0)"
}), /*#__PURE__*/React.createElement("rect", {
  width: "1.5",
  height: "7.5",
  x: "11.25",
  y: "5.25",
  fill: "#F96",
  fillRule: "nonzero",
  strokeWidth: "1.5",
  rx: ".75"
}), /*#__PURE__*/React.createElement("rect", {
  width: "1.5",
  height: "1.5",
  x: "11.25",
  y: "15.75",
  fill: "#F96",
  fillRule: "nonzero",
  strokeWidth: "1.5",
  rx: ".75",
  transform: "matrix(1 0 0 -1 0 33)"
}));
var CircularWarningIcon = function CircularWarningIcon(_ref) {
  var width = _ref.width,
    height = _ref.height;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width || '24',
    height: height || '24',
    viewBox: "0 0 24 24"
  }, _ref2);
};
export default CircularWarningIcon;